import React from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import { mapInvoiceStreamName } from '@/shared/services/ObjectDisplayService';
import FormGroupPart from './FormGroupPart';
import { invoiceStreamShape } from '../registrationHelpers';
import messages from '../registrationMessages';
import { dynamicSortMultiple } from '../../../utils/dynamicSort';

const AssignmentFormGroup = ({ invoiceStreams, value, onChange, readOnly, disabled, intl }) => {
  if (!invoiceStreams || invoiceStreams.length <= 1) return null;

  if (readOnly) {
    const stream = invoiceStreams.find(x => x.id === value);
    return (
      <div className="form-group">
        <FormGroupPart label={messages.Assignment} inputCols="col-sm-10">
          <span>{mapInvoiceStreamName(stream, intl)}</span>
        </FormGroupPart>
      </div>
    );
  }
  const streams = invoiceStreams
    .filter(x => x.isActive || x.id === value)
    .map(x => ({ ...x, label: x.label || mapInvoiceStreamName(x, intl) }))
    .sort(dynamicSortMultiple('isActive', '-isMain', 'label'));

  return (
    <div className="form-group">
      <FormGroupPart label={messages.Assignment} inputCols="col-sm-10">
        <select
          value={value || ''}
          className="form-control"
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
        >
          {streams.map(x => (
            <option key={x.id} value={x.id}>
              {x.label}
            </option>
          ))}
        </select>
      </FormGroupPart>
    </div>
  );
};
AssignmentFormGroup.propTypes = {
  invoiceStreams: PropTypes.arrayOf(invoiceStreamShape),
  value: PropTypes.string, // InvoiceStreamId
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
};
AssignmentFormGroup.defaultProps = {
  invoiceStreams: [],
  value: null,
  onChange: () => {},
  readOnly: false,
  disabled: false,
};
export default AssignmentFormGroup;
